<template>
  <div>
    <div class="all-wrapper">
      <div class="dropdown-wrapper" :style="sizeStyleAppend" ref="sizeget">
        <div class="dropdown-text" :style="sizeStyleAppend">
          <svg-b-event
            v-if="tpxwidth !== null"
            @click="isActive = !isActive"
            :icon-color="iconColor"
            :width="pxwidth"
            :height="pxheight"
            sign="pulldown"
            contentszoom="none"
            :push-color="pushColor"
            ref="eventer"
            @adjustBounds="adB"
            :disable-when-mount="isDisable"
		  >
            <text
              id="pulldown"
			  :[vdFont]="font"
			  :[vdFontSize]="fontsize"
			  :[vdFontWeight]="fontweight"
			  fill="currentColor"
			  :x="centerWidth"
			  :y="centerHeight"
			  text-anchor="middle"
			  dominant-baseline="middle"
			  pointer-events="none"
			>
              {{ label }}
            </text>
          </svg-b-event>
        </div>
        <i class="el-icon-caret-bottom"></i>
      </div>
      <div style="position: fixed; left: 0; top: 0; width: 100vw; height: 100vh;" v-if="isActive" @click="cancelAction"></div>
      <transition>
        <div class="list-items" :style="{ width: listItemWidth }"  v-if="isActive">
          <template v-if="existsListItems">
            <template v-for="(value, key) in listItems">
            <div
              class="list-item"
              :class="[key == activeItemKey ? 'active' : '']"
			  :style="{ height: listItemHeight, paddingTop: '0px', paddingBottom: '1px'}"
              @click="handleClickItem(key)"
            >
                <slot v-bind:value="value">
                  <div class="no-pointer" :style="{ display: 'flex', height: itemHeight, justifyContent: 'flex-start', alignItems: 'center' }">
                    <template v-if="listKind == 'icon'">
                      <img
                        v-if="hasIcon(value)"
                        :src="imageSource(value.icon)"
                        alt="icon"
                        :[srcsetTag(value.icon)]="imageSources(value.icon)"
                        :width="itemIconSize + 'px'"
                        :height="itemIconSize + 'px'"
                      />
                      <div
						:style="{  marginLeft: '12px'}"
                        >{{ value.exp }} </div>
                    </template>
                    <template v-else>
                      <img
                        :[imageWidthTag]="value.imageWidth"
                        :[srcsetTag(value.image)]="imageSources(value.image)"
                        :align="imagePosition(value)"
                        :src="imageSource(value.image)"
                        alt="logo"
                        v-if="hasImage(value)"
						:style="{ marginRight: '12px'}"
					  />
                      {{ value.name }}
                    </template>
                  </div>
				</slot>
            </div>
            </template>
          </template>
          <template v-else>
            <div class="list-item">
              選択肢がありません
            </div>
          </template>
        </div>
      </transition>
    </div>
    <div class="dropdown-bg use-pointer" @click="cancelAction" v-if="isActive"></div>
  </div>
</template>

<script>
let debugOut = false
import {mapGetters} from 'vuex'
import SVGBMouseEvent from "@/components/SVGBMouseEventSlot";
export default {
  name: "SVGBPulldown",
  components: {
    SvgBEvent: SVGBMouseEvent
  },
  props: {
  	label: {
	  type: String,
	  required: false,
	  default: 'プルダウン'
	},
    listItems: {
      // type: Object,
      required: true,
      default: null,
    },
    listItemsInfo: {
  	  type: Object,
      default: null,
    },
	listKind: {
	  type: String,
	  required: false,
	  default: 'plain'
	},
    activeItemKey: {
      type: [String, Number],
      required: false
    },
    action: {
      type: Function,
      required: true
    },
    abort: {
      type: Function,
      required: false,
      default: null
    },
    width: {
      type: [Number, String],
      default: 300
    },
    height: {
      type: [Number, String],
      default: 40
    },
    itemWidth: {
  		type: [Number, String],
      default: null
	},
	itemHeight: {
  		type: [Number, String],
	  	default: null
	},
	itemIconSize: {
  		type: Number,
	  	default: 40
	},
    font: {
      type: String,
      default: null
    },
    fontsize: {
      type: Number,
      default: 0
    },
    fontweight: {
      type: String,
      default: null
    },
    pushColor: {
  	  type: String,
      default: null
    },
    disableWhenMount: {
  	  type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isDisable: false,
      isActive: false,
      tpxwidth: null,
      tpxheight: null,
   };
  },
  watch: {
    isDisable(nv, ov) {
      this.$refs.eventer.isDisable = nv;
      //Vue.set(this.$refs.eventer,'isDisable',nv);
    },
    // documentAreaWatcher(nv) {
    //   this.adjustBounds()
    // },
  },
  created() {
    debugOut = this.$root.$options.debugOut
  },
  mounted() {
    this.isDisable = this.disableWhenMount
    this.adjustBounds()
    // if (debugOut) {
    //   console.log(`Pulldown (wh): ${this.width} x ${this.height}`)
    //   console.log(`Pulldown : ${this.pxwidth} x ${this.pxheight}`)
    //   console.log(this.$refs.sizeget)
    // }
   },
  computed: {
    pxwidth: {
      get() { return this.tpxwidth || 0 },
      set(nv) { this.tpxwidth = nv }
    },
    pxheight: {
      get() { return this.tpxheight || 0 },
      set(nv) { this.tpxheight = nv }
    },
    existsListItems() { return this.listItems && Object.keys(this.listItems).length },
    imageWidthTag(v) { return !v.hasOwnProperty("imageWidth") ? "pxwidth" : null; },
    iconColor() { return this.defUIIconColor; },
    vdFont() { return this.font == null ? null : "font-family"; },
    vdFontSize() { return !this.fontsize ? null : "font-size"; },
    vdFontWeight() { return this.fontweight == null ? null : "font-weight"; },
	centerWidth () { return this.pxwidth / 2; },
	centerHeight () { return (this.pxheight / 2) + (this.fontsize / 8); },
    listItemWidth() {
      let r = this.itemWidth || this.pxwidth
	  return this.isNumber(r) ? `${(Number(r) + 40)}px` : r
    },
	listItemHeight () {
      return this.itemHeight != null
        ? this.isNumber(this.itemHeight) ? `${this.itemHeight}px` : this.itemHeight
        : (this.listKind == 'icon') ? '40px' : '60px';
	},
	sizeStyleAppend () {
		return {
		  width: this.isNumber(this.width) ? `${this.width}px` : this.width,
		  height: this.isNumber(this.height) ? `${this.height}px` : this.height
		  // 'var_width': `260px`,
		  // 'var_height': `40px`
		}
	},
    ...mapGetters([
        'documentAreaWidth',
        'documentAreaHeight',
        'documentAreaWatcher',
    ]),
  },

  methods: {
    adB() {
      if (debugOut) {console.log('emit adjustBounds')}
      this.adjustBounds()
    },
    adjustBounds() {
      this.$nextTick(() => {
        if (this.$refs.sizeget) {
          this.tpxwidth = this.$refs.sizeget.clientWidth
          this.tpxheight = this.$refs.sizeget.clientHeight
        }
      })
    },
    handleClickItem(key) {
      if (key == this.activeItemKey) {
        return
      }
      if (debugOut) {console.log(`select ${key}`)}
      this.isActive = false
      this.action(key)
    },
    cancelAction() {
      this.isActive = false
      if (this.abort) this.abort()
    },
    hasImage(v) {
      return v.hasOwnProperty("image")
    },
    hasIcon(v) {
      return v.hasOwnProperty("icon")
    },
    imagePosition(v) {
      return v.imageAlign || "left"
    },
    isSVG(name) {
	//  if (debugOut) {console.log(`'${name}' extension is '${name.substring(name.lastIndexOf('.')+1)}' `)}
      if (name.startsWith('data:')) {
        return true
      } else {
        return name.substring(name.lastIndexOf('.') + 1).toUpperCase() == 'SVG'
      }
    },
	srcsetTag(name) {
	  return this.isSVG(name) ? null : 'srcset'
	},
    imageSource(name) {
      if (name.startsWith('data:')) {
        return name
      } else {
        return require("../assets/" + name)
      }
    },
    imageSources(name) {
      if (name.startsWith('data:')) {
        return null
      } else {
        return (
            require("../assets/" + name) + " 1x, " +
            require("../assets/" + name.replace(/(.*)\.(jpe?g|gif|png)/g, "$1@2x.$2")) + " 2x, " +
            require("../assets/" + name.replace(/(.*)\.(jpe?g|gif|png)/g, "$1@3x.$2")) + " 3x"
        )
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.dropdown-bg {
  width: 100vw;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 50;
}
.all-wrapper {
  position: relative;
  background-color: transparent;
  width: fit-content;
  pointer-events: auto;
  /*min-width: 120px;*/

  .dropdown-wrapper {
    color: #666666;

    display: flex;
    align-items: center;

    &:hover {
      cursor: pointer;
    }

    .dropdown-text {
      font-size: 14px;
	}

    i {
      font-size: 10px;
      margin-left: 6px;
    }
  }

  .pulldown-cover {

  }
  .list-items {
    max-height: 300px;
    background-color: #fff;
    border-radius: 2px;
    border: 1px solid #b9bfc9;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
    position: absolute;
    left: 1px;
    overflow-y: scroll;
    z-index: 51;
    padding: 0.5rem 0;

    .list-item {
      color: #333;
      font-size: 14px;
      line-height: 16px;
      padding: 0.75rem 1rem;

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      position: relative;

      &:not(.active):hover {
        background-color: #f3f4f6;
        cursor: pointer;
      }

      &.active {
        color: #fff;
        background-color: #182a4b;
      }
    }
  }
}
.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}

.v-enter {
  transform: translateY(-10px);
}

.v-enter,
.v-leave-to {
  opacity: 0;
}
</style>
